import { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import { useApi } from '../../hooks/useApi';
import TableWithPagination from "./../common/TableWithPagination";
import Modal from "./../common/Modal";

export default function Permisos() {
  const { get, post, put, del } = useApi();
  const [permisos, setPermisos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
    const [form, setForm] = useState({ permissionId: null, permissionName: "", permissionDescription: "", permissionModule: "" });

  // 🚀 Cargar permisos
  const fetchPermisos = async () => {
    setLoading(true);
    const data = await get('ListaPermisos');
    setPermisos(data);
    setLoading(false);
  };

  useEffect(() => {
    fetchPermisos();
  }, []);

  const handleClose = () => {
    setModalOpen(false);
        setForm({
            permissionId: null,
            permissionName: "",
            permissionDescription: "",
            permissionModule: ""
        });
    };

  // 📝 Guardar (crear o editar)
  const handleSave = async () => {
  try {
    // 🚀 siempre usamos POST y enviamos id si existe
    await post('ActualizaPermisos', {
      permissionId: form.permissionId || 0,                  
      permissionName: form.permissionName,
      permissionDescription: form.permissionDescription,
      permissionModule: form.permissionModule,
    });

    setModalOpen(false);                 
    setForm({                            
      permissionId: null,
      permissionName: "",
      permissionDescription: "",
      permissionModule: "",
    });
    fetchPermisos();                     
  } catch (error) {
    console.error('Error al guardar permiso:', error);
  }
};


  const onEdit = (permiso) => {
    console.log('Editando permiso:', permiso);
    setForm({
        permissionId: permiso.permissionId,
        permissionName: permiso.permissionName,
        permissionDescription: permiso.permissionDescription,
        permissionModule: permiso.permissionModule || "", // si tienes el campo modulo
    });
    setModalOpen(true); // abre el modal
    };

  // ❌ Eliminar
  /*const handleDelete = async (id) => {
    if (!window.confirm("¿Seguro que quieres eliminar este permiso?") return;
    await fetch(`/api/permisos/${id}`, { method: "DELETE" });
    fetchPermisos();
    };*/

    const handleDelete = async (row) => {
        const ok = window.confirm("¿Seguro que quieres eliminar este permiso?");
        if (!ok) return;

        //await del(`EliminaPermisos/${permissionId}`);
        console.log(row.permissionId);
        await del("EliminaPermisos", { urlParams: { id: row.permissionId } });
        fetchPermisos();
    };

  // 📊 Columnas de la tabla
  const columns = [
    { header: "Modulo", accessor: "permissionModule" },
    { header: "Permiso", accessor: "permissionName" },
    { header: "Descripción", accessor: "permissionDescription" },
  ];

  return (
    <div className="p-4">
        <div className="flex justify-between items-center pb-2 ">
            <h1 className="text-lg font-bold text-gray-700">Gestión de permisos</h1>
            <button 
                onClick={() => {
                      setForm({ permissionId: null, permissionName: "", permissionDescription: "", permissionModule: "" }); // reset
                    setModalOpen(true); // abrir modal
                }}
                className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" >
            <Icon icon="mdi:plus" className="mr-2" /> Nuevo Permiso
            </button>
        </div>
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
            <div className="p-4">
                <TableWithPagination
                    data={permisos}
                    columns={columns}
                    loading={loading}
                    onEdit={onEdit}
                    onDelete={handleDelete}
                    showView={false}
                    showEdit={true}
                    showDelete={true}
                />
            </div>
        </div>

          {/* 👇 Tu modal reutilizable */}
          <Modal show={modalOpen} onClose={() => setModalOpen(false)} title={form.permissionId ? "Editar Permiso" : "Nuevo Permiso"}>
        <div className="space-y-3">
             {/*<select className="w-full border p-2 rounded"
                      value={form.permissionModule}
                      onChange={(e) => setForm({ ...form, permissionModule: e.target.value })} >
              <option value="">Selecciona un módulo</option>
              <option value="Usuarios">Usuarios</option>
              <option value="Roles">Roles</option>
              <option value="Permisos">Permisos</option>
              <option value="Configuracion">Configuracion cadena</option>
              <option value="Carga DME">Carga DME</option>
              <option value="Log Cargas">Log Cargas</option>
            </select>*/}
          <input
            type="text"
            name="nombrepermiso"
                      placeholder="Modulo"
                      value={form.permissionModule}
            onChange={(e) => setForm({ ...form, permissionModule: e.target.value })}
            className="w-full border p-2 rounded"
          />
          <input
            type="text"
            name="nombre"
                      placeholder="Modulo.permiso"
                      value={form.permissionName}
            onChange={(e) => setForm({ ...form, permissionName: e.target.value })}
            className="w-full border p-2 rounded"
          />
          <textarea
            name="descripcion"
                      placeholder="Descripción"
                      value={form.permissionDescription}
                      onChange={(e) => setForm({ ...form, permissionDescription: e.target.value })}
            className="w-full border p-2 rounded"
          />
        </div>

    
        <div className="flex justify-end gap-2">
            <button
            onClick={() => setModalOpen(false)}
            className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
            >
            Cancelar
            </button>
            <button
            onClick={handleSave}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 flex items-center gap-2"
            >
            <Icon icon="mdi:content-save" />
            Guardar
            </button>
        </div>
      </Modal>
    </div>
  );
}
